import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import '@/mbv-theme.css'
import { installMobileZoomGuard } from '@/lib/mobileZoomGuard'

installMobileZoomGuard()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
